/**
 * Blog constants.
 */

// Pathname for blogs
const BLOG_PATHNAME = "blog";

// Set of top level Blog categories
const BLOG_TERM_TOPICS = "By Topics";
const BLOG_TERM_TRENDS = "By Trends";
const BLOG_TERM_INDUSTRIES = "By Industries";
const BLOG_TERM_AUTHOR = "By Authors";

const BLOG_RESET_FILTERS_TEXT = "blog.clear-filter";
const BLOG_RESET_ALL_FILTERS = "blog.clear-all-filters";
const BLOG_PAGE_SIZE = 9;
const BLOG_NO_RESULTS_TEXT = "blog.no-results-text";
const BLOG_RELATED_POSTS_HEADING = "blog.related-posts-label";
const BLOG_CATEGORIES_HEADING = "blog.categories-heading";
const BLOG_PRELOADER_TEXT = "blog.preloader-text";
const BLOG_KEYWORD_PLACEHOLDER = "blog.search-text";
const COPY_LINK_BUTTON_TOOLTIP_TEXT = "blog-inner.copy-link-button-tootltip-text";
const BLOG_BUTTON_DEFAULT_READ_MORE_TEXT = "Read More"; // This will be loaded as a fallback text only when the microcopy value is not available

/**
 * Content type IDs.
 */
const BLOG_CONTENT_TYPE_ID = "blog";
const BLOG_TERM_CONTENT_TYPE_ID = "blogTerm";
const AUTHOR_CONTENT_TYPE_ID = "author";

/**
 * Mapping of blog categories to their corresponding fields.
 */
const blogCategoryFieldMapping = {
    [BLOG_TERM_TOPICS]: "topic",
    [BLOG_TERM_TRENDS]: "trend",
    [BLOG_TERM_INDUSTRIES]: "industry",
    [BLOG_TERM_AUTHOR]: "author",
};

/* Validation messages */
const BLOG_VALIDATION_NO_RESULTS = "blog.validation-no-results";

const BLOG_BUTTON_TEXT = "blog.button-text";
const BLOG_BUTTON_TYPE = "Green Link";

/**
 * Exported constants.
 */
export {
    BLOG_TERM_TOPICS,
    BLOG_TERM_TRENDS,
    BLOG_TERM_INDUSTRIES,
    BLOG_TERM_AUTHOR,
    BLOG_CONTENT_TYPE_ID,
    BLOG_TERM_CONTENT_TYPE_ID,
    AUTHOR_CONTENT_TYPE_ID,
    blogCategoryFieldMapping,
    BLOG_RESET_FILTERS_TEXT,
    BLOG_RESET_ALL_FILTERS,
    BLOG_NO_RESULTS_TEXT,
    BLOG_RELATED_POSTS_HEADING,
    BLOG_PATHNAME,
    BLOG_VALIDATION_NO_RESULTS,
    BLOG_CATEGORIES_HEADING,
    BLOG_PRELOADER_TEXT,
    BLOG_KEYWORD_PLACEHOLDER,
    COPY_LINK_BUTTON_TOOLTIP_TEXT,
    BLOG_PAGE_SIZE,
    BLOG_BUTTON_DEFAULT_READ_MORE_TEXT,
    BLOG_BUTTON_TEXT,
    BLOG_BUTTON_TYPE,
};
